<template>
  <div>
    <vxe-form
        ref="xForm"
        title-align="right"
        title-width="110"
        :data="editFormData"
        :rules="editFormData.userType === 2 ? formRules2 :formRules1"
        @submit="submitEditUser"
    >
      <div class="headImg" v-if="editFormData.userType === 1">
        <Row>
          <Col span="24">
            <div style="font-size: 14px; font-weight: bold; color: #666666">账户信息</div>
          </Col>
        </Row>
        <Row style="width: 100%; display: flex; align-items: center; margin-top: 14px">
          <Col span="8" style="display: flex; align-items: center">
            <img v-if="headimg == null" class="circleImg" src="~assets/images/common/head.png"/>
            <img v-else class="circleImg" :src="headimg"/>
            <span style="font-size: 16px; margin-left: 20px">{{ nickname }}</span>
          </Col>
        </Row>
        <Row style="width: 100%; display: flex; align-items: center; margin-top: 14px">
          <!--          <Col span="8" class="infoPaddingCss">-->
          <!--            <vxe-form-item-->
          <!--                title="客户名称:"-->
          <!--                field="userName"-->
          <!--                :title-width="80"-->
          <!--                title-align="left"-->
          <!--                span="8"-->
          <!--            >-->
          <!--              <vxe-input-->
          <!--                  style="width: 400px"-->
          <!--                  v-if="isEdit && isHavePermission('baseUserSign:updateUserName')"-->
          <!--                  v-model="editFormData.userName"-->
          <!--                  placeholder="请输入客户名称"-->
          <!--                  @input="(file)=>checkUserName(file)"-->
          <!--              ></vxe-input>-->
          <!--              <span v-bind:class="{ active: isEdit }" v-else>{{-->
          <!--                  editFormData.userName-->
          <!--                }}</span>-->
          <!--            </vxe-form-item>-->
          <!--          </Col>-->

          <Col span="8" class="infoPaddingCss">
            <vxe-form-item title="注册手机号:" field="regisiterNum" :title-width="100" title-align="left" span="24">
              <template>
                <span>{{ editFormData.regisiterNum }}</span>
              </template>
            </vxe-form-item>
          </Col>
          <Col span="8">
            <vxe-form-item title="身份类型:" :title-width="80" field="userCategory" span="24">
              <template>
                <span
                    v-if="!isEdit ||editFormData.identityStatus == 1 || editFormData.identityStatus == 3 || (editFormData.userType == 2 && (editFormData.auditStatus == 1 || editFormData.auditStatus == 3))">{{
                    editFormData.userCategoryStrText
                  }}</span>
                <vxe-select
                    v-else-if="editFormData.identityStatus != 1 && editFormData.identityStatus != 3"
                    v-model="editFormData.userCategoryStr"
                    multiple
                    placeholder="请选择"
                    :options="userCategoryType"
                    transfer
                    @change="clickUserCategory($event)"
                ></vxe-select>
              </template>
            </vxe-form-item>
          </Col>
          <Col span="8">
            <vxe-form-item title="备用联系方式:" field="phoneNum" :title-width="100" title-align="left" span="8">
                <span v-bind:class="{ active: isEdit }" v-if="!isEdit">{{
                    editFormData.phoneNum
                  }}</span>
              <vxe-input
                  v-else-if="isEdit"
                  v-model="editFormData.phoneNum"
                  placeholder="请输入联系方式"
              ></vxe-input>
            </vxe-form-item>
          </Col>
        </Row>
      </div>
      <div class="infoPaddingCss">
        <div v-if="editFormData.userType != null && editFormData.userType == 1">
          <div style="display: flex; align-items: center; margin-bottom: 10px; margin-top: 10px">
            <div class="block-detail">
              <div class="block-tip"></div>
              <span class="block-title">个人信息</span>
            </div>
            <div style="display: flex; align-items: center; margin-left: 14px;"
                 @click="auditAuth(editFormData.auditStatus)">
              <img v-if="editFormData.auditStatus === 0" style="width: 100%; height: 100%"
                   src="@/assets/images/common/wrz.png"/>
              <img v-if="editFormData.auditStatus === 1" style="width: 100%; height: 100%"
                   src="@/assets/images/common/dsh.png"/>
              <img v-if="editFormData.auditStatus === 2" style="width: 100%; height: 100%"
                   src="@/assets/images/common/wtg.png"/>
              <img v-if="editFormData.auditStatus === 3" style="width: 100%; height: 100%"
                   src="@/assets/images/common/yrz.png"/>
              <img v-if="editFormData.auditStatus === 4" style="width: 100%; height: 100%"
                   src="@/assets/images/common/ysx.png"/>
            </div>
            <div
                v-if="editFormData.userCategoryStr && editFormData.userCategoryStr.indexOf('司机') > -1"
                style="display: flex; align-items: center; margin-left: 8px; background: #fff6e5"
                @click="identityAuth(editFormData.identityStatus)"
            >
              <img style="width: 16px; height: 16px" src="@/assets/images/common/sfrz.png"/>
              <span
                  style="display: inline-block; margin-left: 1px; cursor: pointer; color: #f59a23"
              >{{ editFormData.identityStatus | identityStatus }}</span
              >
            </div>
          </div>
          <Row style="margin-top: 21px">
            <!--            <Col span="8" v-if="editFormData.userCategory === 5">-->
            <!--              <vxe-form-item-->
            <!--                  title="身份证有效期至:"-->
            <!--                  field="idCardExpireTime"-->
            <!--                  :title-width="120"-->
            <!--                  title-align="left"-->
            <!--                  span="8"-->
            <!--              >-->
            <!--                <span v-if="!isEdit">{{ editFormData.idCardExpireTime | timeFormatDate }}</span>-->
            <!--                <div v-else style="height: 80px; display: flex; align-items: center">-->
            <!--                  <vxe-input-->
            <!--                      class="formInput"-->
            <!--                      type="date"-->
            <!--                      v-model="editFormData.idCardExpireTime"-->
            <!--                      placeholder="请选择日期"-->
            <!--                  ></vxe-input>-->
            <!--                </div>-->
            <!--              </vxe-form-item>-->
            <!--            </Col>-->
            <Col span="8">
              <vxe-form-item title="身份证正面:" field="idcardFrontUrl" :title-width="120" title-align="left" span="8">
                <upload-img
                    v-if="isEdit && (editFormData.auditStatus == 0 || editFormData.auditStatus == 2 || editFormData.auditStatus == 4 || (editFormData.auditStatus == 3 && editFormData.authSource === 3))"
                    :row="editFormData"
                    :fileKey="'idcardFrontUrl'"
                    :width="80"
                    :height="80"
                    :initFile="editFormData.idcardFrontUrl"
                    :isOcrIdCard="true"
                    :isFront="true"
                    @getOcrIdCard="getOcrIdCard"
                ></upload-img>
                <div
                    class="div-img"
                    v-if="(!isEdit || editFormData.auditStatus == 1 || editFormData.auditStatus == 3 && editFormData.authSource !== 3) && editFormData.idcardFrontUrl">
                  <viewer>
                    <img :src="editFormData.idcardFrontUrl" width="80" height="80"/>
                  </viewer>
                </div>
              </vxe-form-item>
            </Col>
            <Col span="8">
              <vxe-form-item title="身份证反面:" field="idcardBackUrl" :title-width="120" title-align="left" span="8">
                <upload-img
                    v-if="isEdit && (editFormData.auditStatus == 0 || editFormData.auditStatus == 2 || editFormData.auditStatus == 4 || (editFormData.auditStatus == 3 && editFormData.authSource === 3))"
                    :row="editFormData"
                    :fileKey="'idcardBackUrl'"
                    :width="80"
                    :height="80"
                    :initFile="editFormData.idcardBackUrl"
                ></upload-img>
                <div class="div-img"
                     v-if="(!isEdit || editFormData.auditStatus == 1 || editFormData.auditStatus == 3 && editFormData.authSource !== 3) && editFormData.idcardBackUrl">
                  <viewer>
                    <img :src="editFormData.idcardBackUrl" width="80" height="80"/>
                  </viewer>
                </div>
              </vxe-form-item>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <vxe-form-item title="姓名:" field="realName" :title-width="55" title-align="left" span="7">
                <template v-slot:title>
                  <span style="color: #f56c6c; margin-right: 0.2em; font-family: Verdana, Arial, Tahoma">*</span>
                  <span>姓名</span>
                </template>
                <vxe-input
                    v-if="isEdit && hasAcc &&(editFormData.auditStatus == 0 ||editFormData.auditStatus == 2 ||editFormData.auditStatus == 4)"
                    v-model="editFormData.realName"
                    placeholder="请输入姓名"
                ></vxe-input>
                <span v-bind:class="{ active: isEdit }" v-else>{{ editFormData.realName }}</span>
              </vxe-form-item>
            </Col>
            <Col span="8">
              <vxe-form-item title="身份证号:" field="idcardNum" :title-width="100" title-align="left" span="8">
                <template v-slot="scope">
                  <vxe-input
                      v-if="isEdit && (hasAcc || (!hasAcc && oldData.idcardNum === ''))&&(editFormData.auditStatus == 0 ||editFormData.auditStatus == 2 ||editFormData.auditStatus == 4)"
                      v-model="editFormData.idcardNum"
                      placeholder="请输入身份证号"
                      @input="inputIdCardNum(scope)"
                      style="width: 200px;"
                  ></vxe-input>
                  <span v-bind:class="{ active: isEdit }" v-else>{{ editFormData.idcardNum }}</span>
                </template>
              </vxe-form-item>
            </Col>
            <Col span="8">
              <vxe-form-item title="证件地址:" field="regAddr" :title-width="85" title-align="left">
                <span v-if="!isEdit">{{ editFormData.regAddr }}</span>
                <vxe-input v-else v-model="editFormData.regAddr" placeholder="选填"></vxe-input>
              </vxe-form-item>
            </Col>
          </Row>
          <div class="block-detail"
               v-if="editFormData.userCategoryStr && editFormData.userCategoryStr.indexOf('司机') > -1">
            <div class="block-tip"></div>
            <span class="block-title">驾驶证信息</span>
          </div>
          <Row v-if="editFormData.userCategoryStr && editFormData.userCategoryStr.indexOf('司机') > -1"
               style="margin-top: 21px">
            <Col span="8">
              <vxe-form-item
                  title="驾驶证正面:"
                  field="drivingCardFrontUrl"
                  :title-width="120"
                  title-align="left"
                  span="8"
              >
                <upload-img
                    v-if="isEdit && editFormData.identityStatus != 3 && editFormData.identityStatus != 1"
                    :row="editFormData"
                    :fileKey="'drivingCardFrontUrl'"
                    :width="80"
                    :height="80"
                    :initFile="editFormData.drivingCardFrontUrl"
                    :isOcrDriving="true"
                    :isFront="true"
                    @getOcrDriving="getOcrDriving"
                ></upload-img>
                <div
                    class="div-img"
                    v-if="(isEdit && (editFormData.identityStatus == 3 || editFormData.identityStatus == 1) && editFormData.drivingCardFrontUrl) || (!isEdit && editFormData.drivingCardFrontUrl)"
                >
                  <viewer>
                    <img :src="editFormData.drivingCardFrontUrl" width="80" height="80"/>
                  </viewer>
                </div>
              </vxe-form-item>
            </Col>
            <Col span="8">
              <vxe-form-item
                  title="驾驶证副页:"
                  field="drivingCardSubpageUrl"
                  :title-width="120"
                  title-align="left"
                  span="8"
              >
                <upload-img
                    v-if="isEdit && editFormData.identityStatus != 3 && editFormData.identityStatus != 1"
                    :row="editFormData"
                    :fileKey="'drivingCardSubpageUrl'"
                    :width="80"
                    :height="80"
                    :initFile="editFormData.drivingCardSubpageUrl"
                    :isOcrDriving="true"
                    @getOcrDriving="getOcrDriving"
                ></upload-img>
                <div
                    class="div-img"
                    v-if="
                    (isEdit &&
                      (editFormData.identityStatus == 3 || editFormData.identityStatus == 1) &&
                      editFormData.drivingCardSubpageUrl) ||
                    (!isEdit && editFormData.drivingCardSubpageUrl)
                  "
                >
                  <viewer>
                    <img :src="editFormData.drivingCardSubpageUrl" width="80" height="80"/>
                  </viewer>
                </div>
              </vxe-form-item>
            </Col>
          </Row>
          <Row v-if="editFormData.userCategoryStr && editFormData.userCategoryStr.indexOf('司机') > -1"
               style="margin-top: 21px">
            <Col span="8">
              <vxe-form-item title="驾驶证号:" field="driverCardNum" :title-width="120" title-align="left" span="8">
                <span v-if="!isEdit || editFormData.identityStatus == 1 || editFormData.identityStatus == 3">{{
                    editFormData.driverCardNum
                  }}</span>
                <vxe-input
                    v-else-if="isEdit && (editFormData.identityStatus == null || editFormData.identityStatus == 0 || editFormData.identityStatus == 2 || editFormData.identityStatus == 4)"
                    class="formInput"
                    v-model="editFormData.driverCardNum"
                    placeholder="请输入驾驶证号"
                    disabled
                ></vxe-input>
              </vxe-form-item>
            </Col>
            <Col span="8">
              <vxe-form-item title="准驾车型:" field="driverModel" :title-width="120" title-align="left" span="8">
                <span v-if="!isEdit || editFormData.identityStatus == 1 || editFormData.identityStatus == 3">{{
                    editFormData.driverModelText
                  }}</span>
                <Select
                    v-else-if="isEdit && (editFormData.identityStatus == null || editFormData.identityStatus == 0 || editFormData.identityStatus == 2 || editFormData.identityStatus == 4)"
                    v-model="editFormData.driverModel"
                    style="width: 200px"
                >
                  <Option v-for="(item, index) in driver_model" :value="item.value" :key="index">{{ item.label }}
                  </Option>
                </Select>
              </vxe-form-item>
            </Col>
            <Col span="8">
              <vxe-form-item title="驾驶证发证机关:" field="issueAuthority" :title-width="120" title-align="left" span="8">
                <span v-if="!isEdit || editFormData.identityStatus == 1 || editFormData.identityStatus == 3">{{
                    editFormData.issueAuthority
                  }}</span>
                <vxe-input
                    v-else-if="isEdit && (editFormData.identityStatus == null || editFormData.identityStatus == 0 || editFormData.identityStatus == 2 || editFormData.identityStatus == 4)"
                    class="formInput"
                    v-model="editFormData.issueAuthority"
                    placeholder="请输入驾驶证发证机关"
                ></vxe-input>
              </vxe-form-item>
            </Col>
          </Row>
          <Row v-if="editFormData.userCategoryStr && editFormData.userCategoryStr.indexOf('司机') > -1"
               style="margin-top: 21px">
            <Col span="8">
              <vxe-form-item title="驾驶证有效期自:" field="driverBeginTime" :title-width="120" title-align="left" span="8">
                <span v-if="!isEdit || editFormData.identityStatus == 1 || editFormData.identityStatus == 3">{{
                    editFormData.driverBeginTime | timeFormatDate
                  }}</span>
                <vxe-input
                    v-else-if="isEdit && (editFormData.identityStatus == null || editFormData.identityStatus == 0 || editFormData.identityStatus == 2 || editFormData.identityStatus == 4)"
                    class="formInput"
                    type="date"
                    v-model="editFormData.driverBeginTime"
                    placeholder="请选择日期"
                ></vxe-input>
              </vxe-form-item>
            </Col>
            <Col span="8">
              <vxe-form-item title="驾驶证有效期至:" field="driverExpireTime" :title-width="120" title-align="left" span="8">
                <span v-if="!isEdit || editFormData.identityStatus == 1 || editFormData.identityStatus == 3">{{
                    editFormData.driverExpireTime | timeFormatDate
                  }}</span>
                <vxe-input
                    v-else-if="isEdit &&(editFormData.identityStatus == null || editFormData.identityStatus == 0 ||editFormData.identityStatus == 2 || editFormData.identityStatus == 4)"
                    class="formInput"
                    type="date"
                    v-model="editFormData.driverExpireTime"
                    placeholder="请选择日期"
                ></vxe-input>
              </vxe-form-item>
            </Col>
            <Col span="8">
              <vxe-form-item title="所驾驶车辆总重量:" field="weightType" :title-width="150" title-align="left" span="8">
                <span v-if="!isEdit">{{ editFormData.weightType | weightType }}</span>
                <Select v-else v-model="editFormData.weightType" style="width: 200px">
                  <Option v-for="(item, index) in weight_type" :value="item.value" :key="index"
                  >{{ item.label }}
                  </Option>
                </Select>
              </vxe-form-item>
            </Col>
          </Row>
          <div class="block-detail"
               v-if="editFormData.userCategoryStr && editFormData.userCategoryStr.indexOf('司机') > -1">
            <div class="block-tip"></div>
            <span class="block-title">从业资格证信息</span>
          </div>
          <Row v-if="editFormData.userCategoryStr && editFormData.userCategoryStr.indexOf('司机') > -1">
            <Col span="8">
              <vxe-form-item title="从业资格证:" field="qualificationUrl" :title-width="120" title-align="left" span="24">
                <div style="height: 80px; display: flex; align-items: center">
                  <upload-img
                      v-if="
                      isEdit && editFormData.identityStatus != 3 && editFormData.identityStatus != 1
                    "
                      :row="editFormData"
                      :fileKey="'qualificationUrl'"
                      :width="80"
                      :height="80"
                      :initFile="editFormData.qualificationUrl"
                  ></upload-img>
                  <div
                      class="div-img"
                      v-if="
                      (isEdit &&
                        (editFormData.identityStatus == 3 || editFormData.identityStatus == 1) &&
                        editFormData.qualificationUrl) ||
                      (!isEdit && editFormData.qualificationUrl)
                    "
                  >
                    <viewer>
                      <img :src="editFormData.qualificationUrl" width="80" height="80"/>
                    </viewer>
                  </div>
                </div>
              </vxe-form-item>
            </Col>
            <Col span="8">
              <vxe-form-item title="从业资格证号:" field="transportLicenseNum" :title-width="120" title-align="left" span="8">
                <div style="height: 80px; display: flex; align-items: center">
                  <span v-if="
                      !isEdit ||
                      editFormData.identityStatus == 1 ||
                      editFormData.identityStatus == 3
                    "
                  >{{ editFormData.transportLicenseNum }}</span>
                  <vxe-input
                      v-else-if="
                      isEdit &&
                      (editFormData.identityStatus == null ||
                        editFormData.identityStatus == 0 ||
                        editFormData.identityStatus == 2 ||
                        editFormData.identityStatus == 4)
                    "
                      class="formInput"
                      v-model="editFormData.transportLicenseNum"
                      placeholder="请输入从业资格证号"
                      disabled
                  ></vxe-input>
                </div>
              </vxe-form-item>
            </Col>
            <Col span="8">
              <vxe-form-item title="从业资格证有效期至:" field="transportExpireTime" :title-width="150" title-align="left"
                             span="8">
                <div style="height: 80px; display: flex; align-items: center">
                  <span v-if="
                      !isEdit ||
                      editFormData.identityStatus == 1 ||
                      editFormData.identityStatus == 3
                    "
                  >{{ editFormData.transportExpireTime | timeFormatDate }}</span>
                  <vxe-input
                      v-else-if="
                      isEdit &&
                      (editFormData.identityStatus == null ||
                        editFormData.identityStatus == 0 ||
                        editFormData.identityStatus == 2 ||
                        editFormData.identityStatus == 4)
                    "
                      class="formInput"
                      type="date"
                      v-model="editFormData.transportExpireTime"
                      placeholder="请选择日期"
                  ></vxe-input>
                </div>
              </vxe-form-item>
            </Col>
          </Row>
        </div>
      </div>
      <div
          v-if="editFormData.userType != null && editFormData.userType == 2"
          class="infoPaddingCss"
      >
        <div>
          <div style="display: flex; align-items: center; margin-bottom: 10px; margin-top: 20px">
            <div class="block-detail">
              <div class="block-tip"></div>
              <span class="block-title">企业信息</span>
            </div>
            <div style="display: flex; align-items: center; margin-left: 14px;"
                 @click="auditAuth(editFormData.auditStatus)"
            >
              <img v-if="editFormData.auditStatus === 0" style="width: 100%; height: 100%"
                   src="@/assets/images/common/wrz.png"/>
              <img v-if="editFormData.auditStatus === 1" style="width: 100%; height: 100%"
                   src="@/assets/images/common/dsh.png"/>
              <img v-if="editFormData.auditStatus === 2" style="width: 100%; height: 100%"
                   src="@/assets/images/common/wtg.png"/>
              <img v-if="editFormData.auditStatus === 3" style="width: 100%; height: 100%"
                   src="@/assets/images/common/yrz.png"/>
              <img v-if="editFormData.auditStatus === 4" style="width: 100%; height: 100%"
                   src="@/assets/images/common/ysx.png"/>
            </div>
          </div>
          <div>
            <Row>
              <Col span="8">
                <vxe-form-item
                    title="营业执照:"
                    field="businessUrl"
                    :title-width="100"
                    title-align="left"
                    span="24"
                >
                  <div style="height: 80px; display: flex; align-items: center">
                    <upload-img
                        v-if="
                        isEdit && editFormData.auditStatus != 3 && editFormData.auditStatus != 1
                      "
                        :row="editFormData"
                        :fileKey="'businessUrl'"
                        :width="80"
                        :height="80"
                        :initFile="editFormData.businessUrl"
                        :isOcrBusiness="true"
                        @getOcrBusiness="getOcrBusiness"
                    ></upload-img>
                    <div
                        class="div-img"
                        v-if="
                        (isEdit &&
                          (editFormData.auditStatus == 3 || editFormData.auditStatus == 1) &&
                          editFormData.businessUrl) ||
                        (!isEdit && editFormData.businessUrl)
                      "
                    >
                      <viewer>
                        <img :src="editFormData.businessUrl" width="80" height="80"/>
                      </viewer>
                    </div>
                  </div>
                </vxe-form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <vxe-form-item title="企业名称:" field="compName" :title-width="85"
                               title-align="left" class="inputWidthCss">
                  <span v-bind:class="{ active: isEdit }"
                        v-if="!isEdit ||editFormData.auditStatus === 1 ||editFormData.auditStatus === 3 ||editFormData.aboutCompId != null">{{
                      editFormData.compName
                    }}</span>

                  <vxe-input
                      v-else-if="isEdit &&(editFormData.auditStatus === 0 ||editFormData.auditStatus === 2 ||editFormData.auditStatus === 4)"
                      style="width: 300px"
                      v-model="editFormData.compName"
                      placeholder="必填"
                      @input="(file)=>checkCompName(file)"
                      @blur="checkComp"
                  ></vxe-input>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="统一社会信用码:" field="taxNum" :title-width="125" title-align="left">
                  <vxe-input
                      v-if="isEdit && (hasAcc || (!hasAcc && oldData.taxNum === '')) &&(editFormData.auditStatus == 0 ||editFormData.auditStatus == 2 ||editFormData.auditStatus == 4)"
                      v-model="editFormData.taxNum"
                      placeholder="选填"
                      style="width: 200px;"
                  ></vxe-input>
                  <span v-bind:class="{ active: isEdit }" v-else>{{ editFormData.taxNum }}</span>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="注册地址:" field="regAddr" :title-width="85" title-align="left">
                  <span v-if="!isEdit">{{ editFormData.regAddr }}</span>
                  <vxe-input v-else v-model="editFormData.regAddr" placeholder="选填"></vxe-input>
                </vxe-form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <vxe-form-item title="注册电话:" field="regPhone" :title-width="85" title-align="left">
                  <span v-if="!isEdit">{{ editFormData.regPhone }}</span>
                  <vxe-input v-else v-model="editFormData.regPhone" placeholder="必填"></vxe-input>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="开户银行:" field="bankName" :title-width="85" title-align="left">
                  <span v-if="!isEdit">{{ editFormData.bankName }}</span>
                  <vxe-input v-else v-model="editFormData.bankName" placeholder="必填"></vxe-input>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="开户账号:" field="accountNum" :title-width="85" title-align="left">
                  <span v-if="!isEdit">{{ editFormData.accountNum }}</span>
                  <vxe-input v-else v-model="editFormData.accountNum" placeholder="必填"></vxe-input>
                </vxe-form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <vxe-form-item title="归属区域:" field="busiOwnArea" span="8" :title-width="85" title-align="left">
                  <Cascader
                      v-model="editFormData.busiOwnArea"
                      :data="home_port"
                      trigger="hover"
                      style="width: 300px"
                      :disabled="!isEdit"
                  ></Cascader>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="法人姓名:" field="realName" :title-width="85" title-align="left" span="12">
                  <template v-slot:title>
                    <span style="color: #f56c6c; margin-right: 0.2em; font-family: Verdana, Arial, Tahoma">*</span>
                    <span>法人姓名</span>
                  </template>
                  <template v-slot="scope">
                     <span v-bind:class="{ active: isEdit }"
                           v-if="!isEdit || editFormData.auditStatus == 1 || editFormData.auditStatus == 3">{{
                         editFormData.realName
                       }}</span>

                    <vxe-input
                        v-else-if="isEdit &&(editFormData.auditStatus == 0 ||editFormData.auditStatus == 2 ||editFormData.auditStatus == 4)"
                        v-model="editFormData.realName"
                        placeholder="必填"
                        @input="$refs.xForm.updateStatus(scope)"
                    ></vxe-input>
                  </template>
                </vxe-form-item>
              </Col>
              <Col span="8" class="infoPaddingCss">
                <vxe-form-item title="绑定手机号:" field="regisiterNum" :title-width="100" title-align="left" span="24">
                  <template>
                    <!--                    <vxe-input v-if="isEdit && editFormData.auditStatus !== 3" v-model="editFormData.regisiterNum"-->
                    <!--                               placeholder="请输入手机号">-->
                    <!--                    </vxe-input>-->
                    <span>{{ editFormData.regisiterNum }}</span>
                  </template>
                </vxe-form-item>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div
          v-if="editFormData.userType == 2 && (editFormData.isShowTransportLic && editFormData.userType != null || isEdit) "
          class="infoPaddingCss"
      >
        <div>
          <div class="block" style="margin-bottom: 20px;">
            <div class="block-tip"></div>
            <span class="block-title">运输证信息</span>
            <i-switch v-if="isEdit" style="margin-left: 5px;" v-model="editFormData.isShowTransportLic"></i-switch>
          </div>
          <div style="border: 0px solid rgba(232, 234, 236, 1); border-bottom: 0px"
               v-if="editFormData.isShowTransportLic">
            <Row>
              <Col span="8">
                <vxe-form-item title="运输经营许可证：" field="transportLicenseUrl" :title-width="150" title-align="right"
                               span="8">
                  <div style="height: 80px; display: flex; align-items: center">
                    <upload-img
                        v-if="isEdit && editFormData.auditStatus != 3 && editFormData.auditStatus != 1"
                        :row="editFormData"
                        :fileKey="'transportLicenseUrl'"
                        :width="80"
                        :height="80"
                        :initFile="editFormData.transportLicenseUrl"
                    ></upload-img>
                    <div
                        class="div-img"
                        v-if="(isEdit &&
                          (editFormData.auditStatus == 3 || editFormData.auditStatus == 1) &&
                          editFormData.transportLicenseUrl) ||
                        (!isEdit && editFormData.transportLicenseUrl)
                      "
                    >
                      <viewer>
                        <img :src="editFormData.transportLicenseUrl" width="80" height="80"/>
                      </viewer>
                    </div>
                  </div>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="经营许可证号：" field="businessLicenseNum" :title-width="150" title-align="left"
                               span="8">
                  <div style="height: 80px; display: flex; align-items: center">
                    <span v-bind:class="{ active: isEdit }"
                          v-if="!isEdit || editFormData.auditStatus == 1 || editFormData.auditStatus == 3">{{
                        editFormData.businessLicenseNum
                      }}</span>
                    <vxe-input
                        v-else-if="isEdit &&(editFormData.auditStatus == 0 || editFormData.auditStatus == 2 || editFormData.auditStatus == 4)"
                        v-model="editFormData.businessLicenseNum"
                        placeholder="必填"
                    ></vxe-input>
                  </div>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="有效期至：" field="businessExpireTime" title-align="left" span="8">
                  <div style="height: 80px; display: flex; align-items: center">
                    <span
                        v-bind:class="{ active: isEdit }"
                        v-if="!isEdit || editFormData.auditStatus == 1 || editFormData.auditStatus == 3">{{
                        editFormData.businessExpireTime | timeFormatDate
                      }}</span>

                    <vxe-input
                        v-else-if="isEdit &&(editFormData.auditStatus == 0 || editFormData.auditStatus == 2 || editFormData.auditStatus == 4)"
                        class="formInput"
                        type="date"
                        v-model="editFormData.businessExpireTime"
                        placeholder="请选择日期"
                    ></vxe-input>
                  </div>
                </vxe-form-item>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div
          v-if="editFormData.userType != null && editFormData.userType == 2"
          class="infoPaddingCss"
      >
        <div>
          <div class="block-detail">
            <div class="block-tip"></div>
            <span class="block-title">联系人信息</span>
          </div>
          <div>
            <Row>
              <Col span="8">
                <vxe-form-item
                    title="姓名:"
                    field="linkman"
                    :title-width="55"
                    title-align="left"
                    span="7"
                >
                  <span v-if="!isEdit">{{ editFormData.linkman }}</span>

                  <vxe-input v-else v-model="editFormData.linkman" placeholder="选填"></vxe-input>
                </vxe-form-item>
              </Col>
              <Col span="16">
                <vxe-form-item
                    title="联系方式:"
                    field="phoneNum"
                    :title-width="70"
                    title-align="left"
                    span="7"
                >
                  <span v-if="!isEdit">{{ editFormData.phoneNum }}</span>

                  <vxe-input v-else v-model="editFormData.phoneNum" placeholder="选填"></vxe-input>
                </vxe-form-item>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div v-if="editFormData.userType != null && editFormData.userType == 2 && editFormData.regisiterNum"
           class="infoPaddingCss">
        <div>
          <div class="block-detail">
            <div class="block-tip"></div>
            <span class="block-title">管理员信息</span>
          </div>
          <div>
            <Row>
              <Col span="8">
                <vxe-form-item
                    title="管理员类型:"
                    field="managerType"
                    :title-width="85"
                    title-align="left"
                    span="12"
                >
                  <span>{{ editFormData.realName === editFormData.managerName ? '法定代表人' : '非法定代表人' }}</span>
                  <!--                  <vxe-select-->
                  <!--                      v-else-if="-->
                  <!--                      isEdit &&-->
                  <!--                      (editFormData.auditStatus == 0 ||-->
                  <!--                        editFormData.auditStatus == 2 ||-->
                  <!--                        editFormData.auditStatus == 4)-->
                  <!--                    "-->
                  <!--                      v-model="editFormData.managerType"-->
                  <!--                      placeholder="请选择"-->
                  <!--                      :options="managerType"-->
                  <!--                      transfer-->
                  <!--                  ></vxe-select>-->
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item
                    title="真实姓名:"
                    field="managerName"
                    :title-width="85"
                    title-align="left"
                    span="12"
                >
                  <span>{{ editFormData.managerName }}</span>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="身份证号:" field="managerIdcardNum" :title-width="100" title-align="left" span="12">
                  <span>{{ editFormData.managerIdcardNum }}</span>
                </vxe-form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <vxe-form-item title="管理员手机号:" field="managerPhone" :title-width="100" title-align="left" span="12">
                  <div style="height: 80px; display: flex; align-items: center">
                    <span>{{ editFormData.managerPhone }}</span>
                  </div>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item
                    title="身份证正面:"
                    field="managerIdcardUrlFront"
                    :title-width="100"
                    title-align="left"
                    span="12"
                >
                  <div style="height: 80px; display: flex; align-items: center">
                    <div class="div-img">
                      <viewer v-if="editFormData.managerIdcardUrlFront">
                        <img :src="editFormData.managerIdcardUrlFront" width="80" height="80"/>
                      </viewer>
                    </div>
                  </div>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item
                    title="身份证反面:"
                    field="managerIdcardUrlBack"
                    :title-width="100"
                    title-align="left"
                    span="12"
                >
                  <div style="height: 80px; display: flex; align-items: center">
                    <div class="div-img">
                      <viewer v-if="editFormData.managerIdcardUrlBack">
                        <img :src="editFormData.managerIdcardUrlBack" width="80" height="80"/>
                      </viewer>
                    </div>
                  </div>
                </vxe-form-item>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="infoPaddingCss">
        <div>
          <div class="block-detail">
            <div class="block-tip"></div>
            <span class="block-title">关联信息</span>
          </div>
          <div>
            <Row style="margin-top: 21px">
              <Col span="8">
                <vxe-form-item
                    title="业务员:"
                    field="salesManName"
                    :title-width="70"
                    title-align="left"
                    span="7"
                >
                  <span>{{ salesManName }}</span>
                </vxe-form-item>
              </Col>
              <Col span="16" v-if="editFormData.userType == 2">
                <vxe-form-item
                    title="关联企业:"
                    field="aboutCompName"
                    :title-width="70"
                    title-align="left"
                    span="7"
                >
                  <span>{{ editFormData.aboutCompName }}</span>
                </vxe-form-item>
              </Col>
            </Row>
          </div>
        </div>
        <div style="height: 100px" v-if="editFormData.userType == 1"></div>
      </div>
      <vxe-form-item align="right" span="24" style="margin-top: 20px" v-if="isEdit">
        <vxe-button style="width: 140px; border-radius: 0px" @click="cancel()">取消</vxe-button>
        <vxe-button type="submit" status="primary" style="width: 140px; border-radius: 0px"
        >保存
        </vxe-button
        >
      </vxe-form-item>
      <vxe-form-item align="right" span="24" style="margin-top: 20px"
                     v-if="!isEdit && edit && ((editFormData.userType === 1 && isHavePermission('user:person:edit')) || (editFormData.userType === 2 && isHavePermission('user:company:edit')))">
        <vxe-button status="primary" style="width: 140px; border-radius: 0px" @click="isEdit = true">编辑</vxe-button>
      </vxe-form-item>
    </vxe-form>
    <vxe-modal v-model="isShowChangePhone" width="400" height="230" position="center">
      <div slot="title">变更手机号</div>
      <!-- <div v-show="changePhoneStep === 1">
        <vxe-form
          title-align="right"
          title-width="110"
          :data="oldPhone"
          :rules="oldPhoneFormRules"
          @submit="getCode(2)"
        >
          <vxe-form-item
            title="旧手机号:"
            field="num"
            :title-width="100"
            title-align="right"
            span="24"
          >
            <vxe-input v-model="oldPhone.num" readonly></vxe-input>
          </vxe-form-item>
          <vxe-form-item
            title="短信验证码:"
            field="code"
            :title-width="100"
            title-align="right"
            span="24"
          >
            <vxe-input v-model="oldPhone.code">
              <template #suffix>
                <span @click="getCode(1)" class="input-code-txt"
                  >获取验证码</span
                >
              </template>
            </vxe-input>
          </vxe-form-item>
          <vxe-form-item align="center" span="24" style="margin-top:10px">
            <vxe-button
              type="submit"
              status="primary"
              style="width: 140px; border-radius: 0px"
              >下一步</vxe-button
            >
          </vxe-form-item>
        </vxe-form>
      </div> -->
      <div>
        <vxe-form
            title-align="right"
            title-width="110"
            :data="newPhone"
            :rules="newPhoneFormRules"
            @submit="getCode(4)"
        >
          <vxe-form-item
              title="新手机号:"
              field="num"
              :title-width="100"
              title-align="right"
              span="24"
          >
            <vxe-input v-model="newPhone.num"></vxe-input>
          </vxe-form-item>
          <!-- <vxe-form-item
            title="短信验证码:"
            field="code"
            :title-width="100"
            title-align="right"
            span="24"
          >
            <vxe-input v-model="newPhone.code">
              <template #suffix>
                <span @click="getCode(3)" class="input-code-txt"
                  >获取验证码</span
                >
              </template>
            </vxe-input>
          </vxe-form-item> -->
          <vxe-form-item align="center" span="24" style="margin-top: 10px">
            <vxe-button type="submit" status="primary" style="width: 140px; border-radius: 0px"
            >确认
            </vxe-button
            >
          </vxe-form-item>
        </vxe-form>
      </div>
    </vxe-modal>
    <vxe-modal v-model="wyTip" position="center" title="消息通知">
      <div style="display: flex; flex-direction: column">
        <div style="display: flex; align-items: center">
          <img v-if="msgErr" src="@/assets/images/common/msgSuccess.png" style="width: 22px;height: 22px;"/>
          <img v-else src="@/assets/images/common/msgErr.png" style="width: 22px;height: 22px;"/>
          <span style="margin-left: 10px">{{ msg }}</span>
        </div>
        <div style="margin-left: auto; margin-top: 20px">
          <Button style="border-radius: 5px" @click="cancelCreate">返回编辑</Button>
          <Button type="primary" style="margin-left: 10px; border-radius: 5px" @click="addGcdUserModel">确认
          </Button>
        </div>
      </div>
    </vxe-modal>
    <vxe-modal v-model="perAuthVisible" title="个人认证" width="1000" height="700" resize
               position="center">
      <per-authentication ref="perAuth" @close="perAuthVisible = false"></per-authentication>
    </vxe-modal>
    <vxe-modal v-model="compAuthVisible" title="企业认证" width="1000" height="800" resize
               position="center">
      <comp-authentication ref="compAuth" @close="compAuthVisible = false"></comp-authentication>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import Vue from "vue";
import {showLoading, hideLoading} from "@/utils/util";
import auth from "@/utils/auth";
import $C from "@/consts";
import UploadImg from "@/components/common/UploadImg";
import {apiPost} from "@/utils/api";
import getAuthOrization from "@/mixin/getAuthOrization";
import perAuthentication from "@/views/account/perAuthentication";
import compAuthentication from "@/views/account/compAuthentication";

Vue.use(Viewer);

export default {
  props: {
    userId: Number,
    isUserEdit: Boolean,
    salesManName: String,
    edit: {
      type: Boolean,
      default: true,
    },
  },
  components: {UploadImg, perAuthentication, compAuthentication},
  mixins: [getAuthOrization],
  data() {
    const realNameValid = ({cellValue}) => {
      if (this.editFormData.userType != null && this.editFormData.userType === 1) {
        if (this.editFormData.realName == null || this.editFormData.realName === "") {
          return Promise.reject(new Error("请输入姓名"));
        }
      }
    };
    return {
      msgErr: false,
      wyTip: false,
      msg: '',
      editFormData: {},
      showUserCategory: null,
      tableData: [],
      tableData2: [],
      userCategoryData: {
        options: [],
      },
      userCategoryMap: new Map(),
      userCategoryTwoMap: new Map(),
      userCategoryTwoData: {
        options: [],
      },
      userCategoryType: [{
        label: '货主',
        value: '货主'
      },
        {
          label: '船东',
          value: '船东'
        },
        {
          label: '司机',
          value: '司机'
        },
        {
          label: '代理',
          value: '代理'
        },
        {
          label: '船员',
          value: '船员'
        },
        {
          label: '供应商',
          value: '供应商'
        },
        {
          label: '其他',
          value: '其他'
        }
      ],
      nickname: null,
      headimg: null,
      uploadHeaders: {
        Authorization: auth.getAuth().token,
        token: auth.getAuth().token,
      },
      formRules1: {
        nickname: [{required: true, message: "请输入昵称"}],
        compName: [{required: true, message: "请输入正确的企业名称"}],
        realName: [{required: true, validator: realNameValid}],
        idcardNum: [{min: 18, max: 18, message: "请输入正确的身份证号"}],
        driverCardNum: [{min: 18, max: 18, message: "请输入正确的驾驶证号"}],
        transportLicenseNum: [{min: 18, max: 18, message: "请输入正确的从业资格证号"}],
        taxNum: [{min: 18, max: 18, required: true, message: "请输入正确的统一社会信用码",},],
        // regAddr: [{required: true, message: "请输入正确的注册地址"}],
        regisiterNum: [{min: 11, max: 11, message: "请输入正确的手机号"}],
        managerPhone: [{min: 11, max: 11, message: '请输入正确的手机号'}],
      },
      formRules2: {
        realName: [{required: true, validator: realNameValid}],
        nickname: [{required: true, message: "请输入昵称"}],
        compName: [{required: true, message: "请输入正确的企业名称"}],
        idcardNum: [{min: 18, max: 18, message: "请输入正确的身份证号"}],
        driverCardNum: [{min: 18, max: 18, message: "请输入正确的驾驶证号"}],
        transportLicenseNum: [{min: 18, max: 18, message: "请输入正确的从业资格证号"}],
        taxNum: [{min: 18, max: 18, required: true, message: "请输入正确的统一社会信用码",},],
        // regAddr: [{required: true, message: "请输入正确的注册地址"}],
        regisiterNum: [{min: 11, max: 11, message: "请输入正确的手机号"}],
        regPhone: [{min: 11, max: 11, message: '请输入正确的手机号'}],
        busiOwnArea: [{required: true, message: '请选择归属区域'}],
        managerPhone: [{min: 11, max: 11, message: '请输入正确的手机号'}],
        // bankName: [{required: true, message: "请输入开户银行"}],
        // accountNum: [{required: true, message: "请输入开户账号"}],
        transportLicenseUrl: [{required: true, message: "请上传运输经营许可证"}],
        businessLicenseNum: [{required: true, message: "请输入经营许可证号"}],
        businessExpireTime: [{required: true, message: "请选择有效期"}],
      },
      oldPhoneFormRules: {
        num: [{required: true, message: "请输入旧手机号"}],
        code: [{required: true, min: 4, max: 4, message: "请输入验证码"}],
      },
      newPhoneFormRules: {
        num: [{required: true, min: 11, max: 11, message: "请输入新手机号"}],
        // code: [{ required: true, min: 4, max: 4, message: "请输入验证码" }]
      },
      dict: [],
      isEdit: false,
      driver_model: [],
      oldData: {},
      home_port: [],
      weight_type: [
        {
          label: "大于4.5吨",
          value: 1,
        },
        {
          label: "小于等于4.5吨",
          value: 2,
        },
      ],
      managerType: [
        {
          label: "法定代表人",
          value: 1,
        },
        {
          label: "非法定代表人",
          value: 2,
        },
      ],
      isShowChangePhone: false,
      changePhoneStep: 1,
      oldPhone: {
        num: "",
        code: "",
      },
      newPhone: {
        num: "",
        // code: ""
      },
      perAuthVisible: false,
      compAuthVisible: false,
      hasAcc: true
    };
  },
  filters: {
    managerType(val) {
      if (val != null) {
        if (val === 1) {
          return "法定代表人";
        }
        if (val === 2) {
          return "非法定代表人";
        }
      }
    },
    identityStatus(val) {
      if (val === null || val === 0) {
        return "未认证";
      }
      if (val === 1) {
        return "待审核";
      }
      if (val === 2) {
        return "未通过";
      }
      if (val === 3) {
        return "已认证";
      }
      if (val === 4) {
        return "已失效";
      }
    },
    auditStatusRule(val) {
      if (val != null) {
        if (val === 0) {
          return "未认证";
        }
        if (val === 1) {
          return "待审核";
        }
        if (val === 2) {
          return "未通过";
        }
        if (val === 3) {
          return "已认证";
        }
        if (val === 4) {
          return "已失效";
        }
      }
    },
    userCategoryRule(val) {
      if (val != null) {
        if (val === 1) {
          return "托运人";
        }
        if (val === 2) {
          return "承运人";
        }
        if (val === 3) {
          return "代理";
        }
        if (val === 4) {
          return "货车承运商";
        }
        if (val === 5) {
          return "司机";
        }
        if (val === 6) {
          return "船东";
        }
        if (val === 7) {
          return "其他";
        }
      }
    },
    weightType(val) {
      if (val != null) {
        if (val === 1) {
          return "大于4.5吨";
        }
        if (val === 2) {
          return "小于等于4.5吨";
        }
      }
    },
  },
  created() {
    if (this.userId != 0) {
      this.getAllDict();
      if (this.isUserEdit == true) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
    }
    this.getDict(40500, "driver_model");
    this.getHomePort();
    this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
  },
  mounted() {
    this.$bus.$on("reFlash", (data) => {
      data === true ? this.getDetail(this.userId) : "";
    });
  },
  methods: {
    inputIdCardNum(scope) {
      this.editFormData.driverCardNum = this.editFormData.idcardNum;
      this.editFormData.transportLicenseNum = this.editFormData.idcardNum;
      this.$refs.xForm.updateStatus(scope);
    },
    getOcrDriving(data) {
      if (data.zhenghao) {
        this.$set(this.editFormData, 'driverCardNum', data.zhenghao);
      }
      if (data.zhunjiachexing) {
        let driverModel = null;
        this.driver_model.map(i => {
          if (i.label === data.zhunjiachexing) {
            driverModel = i.value;
          }
        })
        this.$set(this.editFormData, 'driverModel', driverModel);
      }
      if (data.fazhengdanwei) {
        this.$set(this.editFormData, 'issueAuthority', data.fazhengdanwei);
      }
      if (data.youxiaoqishiriqi) {
        let date = this.insertStr(data.youxiaoqishiriqi, 4, '-');
        date = this.insertStr(date, 7, '-');
        this.$set(this.editFormData, 'driverBeginTime', date);
      }
      if (data.shixiaoriqi) {
        let date = this.insertStr(data.shixiaoriqi, 4, '-');
        date = this.insertStr(date, 7, '-');
        this.$set(this.editFormData, 'driverExpireTime', date);
      }
    },
    getOcrBusiness(data) {
      this.$set(this.editFormData, 'compName', data.danweimingcheng.replace('(', '（').replace(')', '）'));
      this.$set(this.editFormData, 'taxNum', data.shehuixinyongdaima);
      this.$set(this.editFormData, 'regAddr', data.dizhi);
      this.$set(this.editFormData, 'realName', data.faren);
      this.checkComp();
    },
    insertStr(source, start, newStr) {
      return source.slice(0, start) + newStr + source.slice(start)
    },
    getOcrIdCard(data) {
      if (data.xingming) {
        this.$set(this.editFormData, 'realName', data.xingming);
      }
      if (data.shenfenzhenghaoma) {
        this.$set(this.editFormData, 'idcardNum', data.shenfenzhenghaoma);
      }
      if (this.editFormData.userCategoryStr && this.editFormData.userCategoryStr.indexOf('司机') > -1) {
        this.$set(this.editFormData, 'driverCardNum', data.shenfenzhenghaoma);
        this.$set(this.editFormData, 'transportLicenseNum', data.shenfenzhenghaoma);
      }
      if (data.zhuzhi) {
        this.$set(this.editFormData, 'regAddr', data.zhuzhi);
      }
    },
    async getHomePort() {
      showLoading()
      let res = await $api.xcwDict.request('queryProCityAreaList');
      hideLoading();
      if (res.code === 1) {
        let province = [];
        res.data.map(i => {
          if (i.cityCodeP === '0') {
            province.push({
              label: i.cityText,
              value: i.cityCode,
              children: []
            })
          }
        })
        province.map(i => {
          res.data.map(j => {
            if (i.value === j.cityCodeP) {
              i.children.push({
                label: j.cityText,
                value: j.cityCode,
                children: []
              })
            }
          })
        })
        province.map(i => {
          i.children.map(j => {
            res.data.map(k => {
              if (j.value === k.cityCodeP) {
                j.children.push({
                  label: k.cityText,
                  value: k.cityCode,
                })
              }
            })
          })
        })

        this.home_port = province;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    checkUserName(e) {
      this.editFormData.userName = e.replace('(', '（').replace(')', '）');
    },
    checkCompName(e) {
      this.editFormData.compName = e.replace('(', '（').replace(')', '）');
    },
    async checkComp() {
      let res = await $api.baseUserSign.get("queryUserInfoByCompName", {
        compName: this.editFormData.compName
      });
      if (res.status === 1) {
        if (res.data.id) {
          this.$XModal.alert({
            message: this.editFormData.compName + '已存在',
            status: "error",
          });
          return
        }
      }
    },
    getAccList() {
      this.loading = true;
      $api.finance.queryAccListModel
          .POST({
            data: {
              page: 1,
              rows: 10,
              subjectType: 1,
              subjectId: this.userId,
              orderBy: 2,
            },
          })
          .then((res) => {
            if (res.status === 1) {
              let accList = res.data.rows;
              if (accList.length > 0) {
                this.hasAcc = false;
              } else {
                this.hasAcc = true;
              }
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          });
    },
    async getCode(step) {
      let params = {};
      params.id = this.userId;
      params.registerNum = this.newPhone.num;
      // params.step = step;
      // if (step === 2) {
      //   params.code = this.oldPhone.code;
      // } else if (step === 3) {
      //   params.code = this.oldPhone.code;
      //   params.newRegisterNum = this.newPhone.num;
      // } else if (step === 4){
      //   params.code = this.oldPhone.code;
      //   params.newRegisterNum = this.newPhone.num;
      //   params.newCode = this.newPhone.code;
      // }
      let res = await apiPost("api/auth/", "baseUserSign/editRegisterNum", params);
      if (res.status === 1) {
        this.$Message.success("变更成功");
        this.editFormData.regisiterNum = this.newPhone.num;
        this.isShowChangePhone = false;
      } else {
        this.$Message.error(res.message);
        // this.$XModal.message({
        //   message: "付款信息必须为全为空或者全不为空",
        // });
        // this.$XModal.message({ content: res.message, status: 'error' })
      }
      // if (res.status === 1) {
      //   if (step === 1 || step === 3) {
      //     this.$Message.success("验证码已发送,请注意查收");
      //   } else if (step === 2) {
      //     this.changePhoneStep = 2;
      //   } else if (step === 4) {
      //     this.$Message.success("变更成功");
      //     this.isShowChangePhone = false;
      //   }
      // } else {
      //   this.$Message.error(res.message);
      // }
    },
    showChangePhone() {
      this.isShowChangePhone = true;
      this.changePhoneStep = 1;
      this.oldPhone.num = this.editFormData.regisiterNum;
      this.oldPhone.code = null;
    },
    async getAllDict() {
      let res = await $api.dict.get("searchDic");
      if (res.status === 1) {
        this.dict = res.data;
        this.getDetail(this.userId);
      } else {
        this.$XModal.message(res.message);
      }
    },
    async getDict(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    handleUpload(file) {
      // 上传
      this.file = file;
      // this.uploadList = this.$refs.upload.fileList;
      let that = this;
      let reader = new FileReader();
      reader.onload = function (e) {
        that.imgUrl = e.target.result;
      };
      reader.readAsDataURL(file);
      console.log(this.file.name);
    },
    copyTemp() {
      this.editFormDataCopy = {
        userAddressBankInfo: [],
        userAddressInfor: [],
      };
      this.editFormDataCopy.id = this.editFormData.id;
      if (this.editFormData.accountName) {
        this.editFormDataCopy.accountName = this.editFormData.accountName.replace(/\s*/g, "");
      }
      this.editFormDataCopy.bankName = this.editFormData.bankName;
      this.editFormDataCopy.accountNum = this.editFormData.accountNum;
      if (this.editFormData.compName) {
        this.editFormDataCopy.compName = this.editFormData.compName.replace(/\s*/g, "");
      }
      this.editFormDataCopy.password = this.editFormData.password;
      this.editFormDataCopy.userType = this.editFormData.userType;
      if (this.editFormData.realName) {
        this.editFormDataCopy.realName = this.editFormData.realName.replace(/\s*/g, "");
      }

      if (this.editFormData.userType === 1) {
        this.editFormDataCopy.userName = this.editFormDataCopy.realName;
      } else {
        this.editFormDataCopy.userName = this.editFormDataCopy.compName;
      }
      this.editFormDataCopy.faxNum = this.editFormData.faxNum;
      this.editFormDataCopy.regisiterNum = this.editFormData.regisiterNum;
      this.editFormDataCopy.idcardNum = this.editFormData.idcardNum;
      this.editFormDataCopy.phoneNum = this.editFormData.phoneNum;
      this.editFormDataCopy.regAddr = this.editFormData.regAddr;
      this.editFormDataCopy.regPhone = this.editFormData.regPhone;
      this.editFormDataCopy.taxNum = this.editFormData.taxNum;
      this.editFormDataCopy.idcardBackUrl = this.editFormData.idcardBackUrl;
      this.editFormDataCopy.businessUrl = this.editFormData.businessUrl;
      this.editFormDataCopy.idcardFrontUrl = this.editFormData.idcardFrontUrl;
      this.editFormDataCopy.userCategory = this.editFormData.userCategory;
      this.editFormDataCopy.transportLicenseUrl = this.editFormData.transportLicenseUrl;
      this.editFormDataCopy.drivingCardFrontUrl = this.editFormData.drivingCardFrontUrl;
      this.editFormDataCopy.qualificationUrl = this.editFormData.qualificationUrl;
      this.editFormDataCopy.drivingCardSubpageUrl = this.editFormData.drivingCardSubpageUrl;
      this.editFormDataCopy.linkman = this.editFormData.linkman;
      this.editFormDataCopy.managerType = this.editFormData.managerType;
      this.editFormDataCopy.managerPhone = this.editFormData.managerPhone;
      this.editFormDataCopy.managerName = this.editFormData.managerName;
      if (this.editFormData.userCategoryStr && this.editFormData.userCategoryStr.length > 0) {
        this.editFormDataCopy.userCategoryStr = this.editFormData.userCategoryStr.toString();
      }

      if (this.editFormData.busiOwnArea) {
        this.editFormDataCopy.busiOwnArea = this.editFormData.busiOwnArea.toString();
      }

      this.editFormDataCopy.isShowTransportLic = this.editFormData.isShowTransportLic ? 1 : 0;

      if (this.editFormData.idCardExpireTime) {
        this.editFormDataCopy.idCardExpireTime = this.$utils.timestamp(
            this.editFormData.idCardExpireTime
        );
      }
      this.editFormDataCopy.driverCardNum = this.editFormData.driverCardNum;
      this.editFormDataCopy.driverModel = this.editFormData.driverModel;
      this.editFormDataCopy.issueAuthority = this.editFormData.issueAuthority;
      if (this.editFormData.driverBeginTime) {
        this.editFormDataCopy.driverBeginTime = this.$utils.timestamp(
            this.editFormData.driverBeginTime
        );
      }
      if (this.editFormData.driverExpireTime) {
        this.editFormDataCopy.driverExpireTime = this.$utils.timestamp(
            this.editFormData.driverExpireTime
        );
      }
      this.editFormDataCopy.weightType = this.editFormData.weightType;
      this.editFormDataCopy.transportLicenseNum = this.editFormData.transportLicenseNum;
      if (this.editFormData.transportExpireTime) {
        this.editFormDataCopy.transportExpireTime = this.$utils.timestamp(
            this.editFormData.transportExpireTime
        );
      }
      if (this.editFormData.businessExpireTime) {
        this.editFormDataCopy.businessExpireTime = this.$utils.timestamp(
            this.editFormData.businessExpireTime
        );
      }
      this.editFormDataCopy.businessLicenseNum = this.editFormData.businessLicenseNum;
      //后端要求传一个字符
      this.editFormDataCopy.password = "password";
      if (this.$refs.xBankTable != null) {
        this.editFormDataCopy.userAddressBankInfo = this.copyDeep(
            this.$refs.xBankTable.getTableData().fullData
        );
      }
      if (this.$refs.xEmailTable != null) {
        this.editFormDataCopy.userAddressInfor = this.copyDeep(
            this.$refs.xEmailTable.getTableData().fullData
        );
      }
    },
    auditAuth(val) {
      //认证状态0.未认证 1.已提交/待审核 2.未通过 3.通过 4.已过期',
      if (this.editFormData.userType != null && this.editFormData.userType === 1) {
        this.perAuthVisible = true;
        this.$nextTick(() => {
          this.$refs.perAuth.init(this.userId);
        })
      } else {
        this.compAuthVisible = true;
        this.$nextTick(() => {
          this.$refs.compAuth.init(this.userId);
        })
      }
    },
    async getAuthInfo() {
      showLoading();
      let res = await $api.authUser.request("getAuthInfo", {
        userId: this.userId,
        userType: 1,
      });
      hideLoading();
      if (res.status === 1) {
        let data = res.data;
        window.open(data.fadadaUrl);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    identityAuth() {
      this.$store.dispatch("tagsView/addVisitedView", {
        name: `身份认证${this.userId}`,
        path: `/account/driverAuthentication/${this.userId}`,
      });
      this.$router.push(`/account/driverAuthentication/${this.userId}`);
    },
    cancel() {
      this.getDetail(this.userId);
      this.$refs.xForm.clearValidate();
    },
    submitEditUser() {
      this.loading = true;
      let self = this;
      if (
          this.editFormData.userType == 1 &&
          (this.editFormData.realName == null || this.editFormData.realName == "")
      ) {
        this.$XModal.alert({
          message: "请输入姓名",
          status: "error",
        });
        this.loading = false;
        return;
      }

      if (this.editFormData.userType == 1 && this.editFormData.realName && this.editFormData.realName !== '') {
        let regName = new RegExp(/^[\u4e00-\u9fa5]+$/);
        if (!regName.test(this.editFormData.realName) || this.editFormData.realName.length < 2 || this.editFormData.realName.length > 18) {
          this.$XModal.alert({
            message: "请输入正确的姓名",
            status: "error",
          });
          this.loading = false;
          return;
        }
      }

      if (this.editFormData.userType === 1 && !this.editFormData.userCategoryStr) {
        this.$XModal.alert({
          message: "请选择身份类型",
          status: "error",
        });
        this.loading = false;
        return;
      }

      if (
          this.editFormData.userType == 2 &&
          (this.editFormData.realName == null || this.editFormData.realName == "")
      ) {
        this.$XModal.alert({
          message: "请输入法人姓名",
          status: "error",
        });
        this.loading = false;
        return;
      }

      let reg = new RegExp(/^[\u4e00-\u9fa5（）]+$/);
      let valid = reg.test(this.editFormData.compName);
      if (
          this.editFormData.userType == 2 &&
          (this.editFormData.compName == null ||
              this.editFormData.compName == "" ||
              this.editFormData.compName.length < 8 ||
              this.editFormData.compName.length > 30 ||
              !valid)
      ) {
        this.$XModal.alert({
          message: "请输入正确的企业名称",
          status: "error",
        });
        this.loading = false;
        return;
      }
      // if (this.editFormData.userType === 1 && (!this.editFormData.regisiterNum || this.editFormData.regisiterNum === '')) {
      //   this.$XModal.alert({
      //     message: "请输入绑定手机号",
      //     status: "error",
      //   });
      //   this.loading = false;
      //   return;
      // }
      let regPhone = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);
      let validPhone = regPhone.test(this.editFormData.regisiterNum);
      if (this.editFormData.regisiterNum && this.editFormData.regisiterNum !== "" && this.editFormData.regisiterNum.length !== 11 && !validPhone) {
        this.$XModal.alert({
          message: "请输入正确的绑定手机号",
          status: "error",
        });
        this.loading = false;
        return;
      }

      // if (this.editFormData.userType === 2 && !this.editFormData.regPhone || this.editFormData.regPhone === "") {
      //   this.$XModal.alert({
      //     message: "请输入注册电话",
      //     status: "error",
      //   });
      //   this.loading = false;
      //   return;
      // }

      if (this.editFormData.userType === 2 && this.editFormData.busiOwnArea && this.editFormData.busiOwnArea.length === 0) {
        this.$XModal.alert({
          message: "请选择归属区域",
          status: "error",
        });
        this.loading = false;
        return;
      }

      // if (this.editFormData.userType === 2 && !this.editFormData.bankName || this.editFormData.bankName === "") {
      //   this.$XModal.alert({
      //     message: "请输入开户银行",
      //     status: "error",
      //   });
      //   this.loading = false;
      //   return;
      // }
      //
      // if (this.editFormData.userType === 2 && !this.editFormData.accountNum || this.editFormData.accountNum === "") {
      //   this.$XModal.alert({
      //     message: "请输入开户账号",
      //     status: "error",
      //   });
      //   this.loading = false;
      //   return;
      // }

      let validPhoneNum = regPhone.test(this.editFormData.phoneNum);
      if (this.editFormData.phoneNum && this.editFormData.phoneNum !== '' && !validPhoneNum) {
        this.$XModal.alert({
          message: "请输入正确的联系方式",
          status: "error",
        });
        this.loading = false;
        return;
      }

      // if (this.editFormData.userType === 1 && (!this.editFormData.idcardNum || this.editFormData.idcardNum === '')) {
      //   this.$XModal.alert({
      //     message: "请输入身份证号码",
      //     status: "error",
      //   });
      //   this.loading = false;
      //   return;
      // }

      let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      let validIDre = _IDRe18.test(this.editFormData.idcardNum) || _IDre15.test(this.editFormData.idcardNum);
      if (this.editFormData.idcardNum && this.editFormData.idcardNum !== "" && this.editFormData.idcardNum.length !== 18 && !validIDre) {
        this.$XModal.alert({
          message: "请输入正确的身份证号码",
          status: "error",
        });
        this.loading = false;
        return;
      }
      if (
          this.editFormData.userType == 2 &&
          (this.editFormData.taxNum == null || this.editFormData.taxNum == "")
      ) {
        this.$XModal.alert({
          message: "请输入社会统一信用码",
          status: "error",
        });
        this.loading = false;
        return;
      }

      let regTax = new RegExp(/^(([0-9A-Z]{18}))$/);
      let validTax = regTax.test(this.editFormData.taxNum);
      if (this.editFormData.userType === 2 && !validTax) {
        this.$XModal.alert({
          message: "请输入正确的统一社会信用码",
          status: "error",
        });
        this.loading = false;
        return;
      }


      // if (
      //     this.editFormData.userType == 2 &&
      //     (this.editFormData.regAddr == null || this.editFormData.regAddr == "")
      // ) {
      //   this.$XModal.alert({
      //     message: "请输入注册地址",
      //     status: "error",
      //   });
      //   this.loading = false;
      //   return;
      // }
      if (
          self.editFormData.userType === 2 &&
          self.editFormData.taxNum &&
          self.editFormData.taxNum !== "" &&
          self.editFormData.taxNum.length !== 18
      ) {
        this.$XModal.alert({
          message: "请输入正确的社会统一信用码",
          status: "error",
        });
        this.loading = false;
        return;
      }

      if (this.editFormData.isShowTransportLic) {
        if (!this.editFormData.transportLicenseUrl) {
          this.$XModal.alert({
            message: "请上传运输经营许可证",
            status: "error",
          });
          this.loading = false;
          return;
        }
        if (!this.editFormData.businessLicenseNum && this.editFormData.businessLicenseNum === "") {
          this.$XModal.alert({
            message: "请输入经营许可证号",
            status: "error",
          });
          this.loading = false;
          return;
        }
        if (!this.editFormData.businessExpireTime && this.editFormData.businessExpireTime === "") {
          this.$XModal.alert({
            message: "请输入有效期",
            status: "error",
          });
          this.loading = false;
          return;
        }
      }

      self.copyTemp();
      let data = self.editFormDataCopy;
      if (this.editFormData.auditStatus === 3) {
        this.addGcdUserModel();
      } else {
        if (this.editFormData.userType === 1 && this.editFormData.regisiterNum && this.editFormData.regisiterNum !== '') {
          if (this.oldPhone !== this.editFormData.regisiterNum) {
            this.getWYMIdlephoneCheck(data);
          } else {
            this.addGcdUserModel();
          }
        } else if (this.editFormData.userType === 2) {
          // if (this.oldData.compName !== data.compName || this.oldData.realName !== data.realName || this.oldData.idcardNum !== data.idcardNum) {
          //   this.$XModal.confirm('企业信息发生变更，客户子账户的企业名称也会进行变更操作，是否继续？').then(type => {
          //     if (type === 'confirm') {
          //       this.addGcdUserModel();
          //     }
          //   })
          // } else {
          this.addGcdUserModel();
          // }
        } else {
          this.addGcdUserModel();
        }
      }
    },
    addGcdUserModel() {
      let data = this.editFormDataCopy;
      new Promise((resolve, reject) => {
        showLoading();
        $api.gcdUser.addGcdUserModel.POST({data})
            .then((response) => {
              hideLoading();
              if (response.status == 1) {
                this.$Message["success"]({
                  background: true,
                  content: "更新成功",
                });
                this.isEdit = false;
                this.wyTip = false;
                this.msg = '';
                this.getDetail(this.userId);
                this.$emit("submitC", true);
              } else {
                this.$XModal.alert({
                  message: response.message ? response.message : "接口异常",
                  status: "error",
                });
                this.loading = false;
              }
            })
            .catch(function (er) {
              hideLoading();
              console.log(er.response.data.message);
              self.$XModal.alert({
                message: er.response.data.message ? er.response.data.message : "接口异常",
                status: "error",
              });
              return;
            });
      });
    },
    async getWYMIdlephoneCheck(data) {
      showLoading();
      let res = await $api.gcdUser.post("getWYMIdlephoneCheck", {
        regisiterNum: data.regisiterNum
      });
      hideLoading();
      if (res.status === 1) {
        let resData = res.data;
        let phoneInfo = res.data.phoneInfo[0];
        if (resData.status === 2) {
          this.msg = '校验失败';
          this.wyTip = true;
          this.msgErr = resData.isPayed === 1;
        }
        if (phoneInfo.status === 0) {
          this.msg = '该手机号为空号';
          this.wyTip = true;
          this.msgErr = resData.isPayed === 1;
        } else {
          this.addGcdUserModel();
        }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    cancelCreate() {
      this.wyTip = false;
      this.msg = '';
    },
    handleRemove(i) {
      // const fileList = this.$refs.upload.fileList;
      // this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      this.$XModal.confirm("您确定要删除该附件吗？").then((type) => {
        if (type === "confirm") {
          if (i == "idcardBackUrl") {
            this.editFormData.idcardBackUrl = null;
          } else if (i == "idcardFrontUrl") {
            this.editFormData.idcardFrontUrl = null;
          } else if (i == "businessUrl") {
            this.editFormData.businessUrl = null;
          } else if (i == "transportLicenseUrl") {
            this.editFormData.transportLicenseUrl = null;
          } else if (i == "qualificationUrl") {
            this.editFormData.qualificationUrl = null;
          } else if (i == "drivingCardFrontUrl") {
            this.editFormData.drivingCardFrontUrl = null;
          } else if (i == "drivingCardSubpageUrl") {
            this.editFormData.drivingCardSubpageUrl = null;
          }
        }
      });
    },
    drivingCardSubpageUrlLoadfile(res) {
      if (res.status === 200 && res.data) {
        // this.uuidList.push(res.data.uuid);
        var obj = {
          url: res.data.url,
          oldFileName: this.file.name,
          uuid: res.data.uuid,
        };
        this.editFormData.drivingCardSubpageUrl = res.data.url;
        this.$nextTick(() => {
          this.initImageTools();
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    drivingCardFrontUrlLoadfile(res) {
      if (res.status === 200 && res.data) {
        // this.uuidList.push(res.data.uuid);
        var obj = {
          url: res.data.url,
          oldFileName: this.file.name,
          uuid: res.data.uuid,
        };
        this.editFormData.drivingCardFrontUrl = res.data.url;
        this.$nextTick(() => {
          this.initImageTools();
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    qualificationUrlLoadfile(res) {
      if (res.status === 200 && res.data) {
        // this.uuidList.push(res.data.uuid);
        var obj = {
          url: res.data.url,
          oldFileName: this.file.name,
          uuid: res.data.uuid,
        };
        this.editFormData.qualificationUrl = res.data.url;
        this.$nextTick(() => {
          this.initImageTools();
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    transportLicenseUrlLoadfile(res) {
      if (res.status === 200 && res.data) {
        // this.uuidList.push(res.data.uuid);
        var obj = {
          url: res.data.url,
          oldFileName: this.file.name,
          uuid: res.data.uuid,
        };
        this.editFormData.transportLicenseUrl = res.data.url;
        this.$nextTick(() => {
          this.initImageTools();
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    idcardBackUrlLoadfile(res) {
      if (res.status === 200 && res.data) {
        // this.uuidList.push(res.data.uuid);
        var obj = {
          url: res.data.url,
          oldFileName: this.file.name,
          uuid: res.data.uuid,
        };
        this.editFormData.idcardBackUrl = res.data.url;
        this.$nextTick(() => {
          this.initImageTools();
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    idcardFrontUrlLoadfile(res) {
      if (res.status === 200 && res.data) {
        // this.uuidList.push(res.data.uuid);
        var obj = {
          url: res.data.url,
          oldFileName: this.file.name,
          uuid: res.data.uuid,
        };
        this.editFormData.idcardFrontUrl = res.data.url;
        this.$nextTick(() => {
          this.initImageTools();
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    businessUrlLoadfile(res) {
      if (res.status === 200 && res.data) {
        // this.uuidList.push(res.data.uuid);
        var obj = {
          url: res.data.url,
          oldFileName: this.file.name,
          uuid: res.data.uuid,
        };
        this.editFormData.businessUrl = res.data.url;
        this.$nextTick(() => {
          this.initImageTools();
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    destroyViewer() {
      this.viewer ? this.viewer.destroy() : "";
    },
    clickUserCategory(val) {
      this.$forceUpdate();
    },
    initImageTools() {
      //初始化 viewerjs
      const ViewerDom = this.$refs.imgbox;
      this.viewer = new Viewer(ViewerDom, {
        url: "data-original",
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          reset: 1,
        },
        show: function () {
          this.viewer.update();
        },
      });
    },
    getDicUserCategoryList(val) {
      var self = this;
      self.userCategoryData.options = [];
      $api.other.getDicUserCategoryModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: item.dictCode,
              };
              self.userCategoryData.options.push(obj);
              self.userCategoryMap.set(item.dictCode, item.dictText);
            });
          });
    },
    getDicUserCategoryTwoList(val) {
      var self = this;
      self.userCategoryTwoData.options = [];
      $api.other.getDicUserCategoryTwoModel
          .GET({
            params: {
              page: 1,
              rows: 10,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: item.dictCode,
              };
              self.userCategoryTwoData.options.push(obj);
              self.userCategoryTwoMap.set(item.dictCode, item.dictText);
            });
            // self.userCategoryType = JSON.parse(JSON.stringify(self.userCategoryTwoData.options));
            if (val != null) {
              this.showUserCategory = this.userCategoryTwoMap.get(val);
            }
          });
    },
    getDetail(id) {
      this.isEdit = false;
      let dict = this.dict;
      var self = this;
      var data = {
        id: id,
        withPermission: 1
      };
      new Promise((resolve, reject) => {
        $api.gcdUser.queryGcdUserModel
            .POST({
              data,
            })
            .then((response) => {
              this.$emit("resStatus", response.status);
              if (response.status === 1) {
                let data = response.data;
                dict.map((i) => {
                  if (parseInt(data.driverModel) === i.dictCode) {
                    data.driverModelText = i.dictText;
                  }
                });
                data.isShowTransportLic = data.isShowTransportLic === 1;
                if (data.busiOwnArea) {
                  data.busiOwnArea = data.busiOwnArea.split(',');
                }
                if (data.businessExpireTime) {
                  data.businessExpireTime = this.$utils.toDateString(data.businessExpireTime, "yyyy-MM-dd");
                }
                if (data.transportExpireTime) {
                  data.transportExpireTime = this.$utils.toDateString(data.transportExpireTime, "yyyy-MM-dd");
                }

                if (data.driverBeginTime) {
                  data.driverBeginTime = this.$utils.toDateString(data.driverBeginTime, "yyyy-MM-dd");
                }

                if (data.driverExpireTime) {
                  data.driverExpireTime = this.$utils.toDateString(data.driverExpireTime, "yyyy-MM-dd");
                }
                data.userCategoryStrText = data.userCategoryStr;
                if (data.userCategoryStr) {
                  data.userCategoryStr = data.userCategoryStr.split(',')
                }

                self.editFormData = data;
                this.oldData = Object.assign({}, data);
                // if (self.editFormData.userType == 1) {
                //   self.getDicUserCategoryList(response.data.userCategory);
                // } else {
                //   self.getDicUserCategoryTwoList(response.data.userCategory);
                // }
                self.headimg = response.data.headimg;

                self.nickname = response.data.nickname;

                self.oldId = response.data.idcardNum;
                self.oldPhone = response.data.regisiterNum;
              }

              // if (response.data.userType == "1"){
              //   self.userCategoryType = JSON.parse(JSON.stringify(self.userCategoryData.options));
              // }
              // else if (response.data.userType == "2"){
              //   self.userCategoryType = JSON.parse(JSON.stringify(self.userCategoryTwoData.options));
              // }
              self.getAccList();
              self.$forceUpdate();
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
      });
    },
  },
};
</script>
<style scoped>
.circleImg {
  border-radius: 30px;
  width: 60px;
  height: 60px;
}

.headImg {
  display: flex;
  flex-direction: column;
}

.upload-list2-wrap {
  display: flex;
  flex-wrap: wrap;
}

.upload-list2 {
  display: inline-block;
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 100px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-left: 4px;
  vertical-align: middle;
  margin-bottom: 10px;
}

.upload-list2 img {
  width: 100%;
  height: 100%;
  border-style: none;
}

.add-box .file-upload-box2 {
  height: 100px;
  width: 100px;
  line-height: 100px;
  border: 1px dashed #dcdee2;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
}

.upload-list2:hover .upload-list2-cover {
  display: block;
}

.upload-list2-cover {
  display: none;
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.6);
  width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
}

.upload-list2-cover i {
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  margin: 0 auto;
  text-indent: 0;
  display: block;
  width: 100%;
  height: 100%;
  line-height: 20px;
}

.upload-list2 .pdf-box2 {
  height: 100px;
  width: 100px;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
}

.fontWeight {
  font-weight: 800;
  margin-bottom: 10px;
  color: #2d8cf0;
  display: inline-block;
}

.active {
  color: #bbb;
}

.block-detail {
  display: flex;
  align-items: center;
}

.block {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.block-tip {
  width: 4px;
  height: 16px;
  background: #539fff;
}

.block-title {
  margin-left: 4px;
  height: 21px;
  font-size: 16px;
  font-weight: bold;
  line-height: 21px;
  color: #539fff;
}

.formInput {
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px;
}

.change-phone-txt,
.input-code-txt {
  display: block;
  width: 50px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #5faeff;
  color: #fff;
  cursor: pointer;
}

.input-code-txt {
  width: 100px;
  position: absolute;
  right: -1px;
  top: 2px;
  border-radius: 0 4px 4px 0;
}
</style>
